import {
  GET_PRE_ORDERS_REQUESTED,
  GET_PRE_ORDERS_SUCCEEDED,
  GET_PRE_ORDERS_FAILED,
} from './constants'
import api from '../../utils/api'

export const getPreOrdersRequested = () => ({
  type: GET_PRE_ORDERS_REQUESTED
})

export const getPreOrdersSucceeded = (payload) => ({
  type: GET_PRE_ORDERS_SUCCEEDED,
  payload
})

export const getPreOrdersFailed = () => ({
  type: GET_PRE_ORDERS_FAILED
})

export const loadPreOrders = (venueUuid, salesEventId) => dispatch => {
  dispatch(getPreOrdersRequested())

  return api
    .fetchPreOrders(venueUuid, salesEventId)
    .then(response => dispatch(getPreOrdersSucceeded(response.data)))
    .catch(() => dispatch(getPreOrdersFailed()))
}
